{
  "breaches": {
    "count": "Vi har ikke funnet noen datalekkasjoner for kontoen din. | Dine kontoinformasjon har blitt lekket i én datalekkasje. | Dine kontoinformasjon har blitt lekket i {count} datalekkasjoner.",
    "discovered": "Denne lekkasje ble først oppdaget den {date}.",
    "empty": {
      "text": "Vi har ikke funnet noen datalekkager for din konto.",
      "title": "Ingen datalekkasje funnet"
    },
    "high": "Høy",
    "medium": "Medium",
    "title": "Datalekkasje",
    "watchlist": {
      "button": "Legg til e-post",
      "text": "E-poster som blir overvåket",
      "title": "Overvåkningsliste"
    }
  },
  "cards": {
    "breaches": {
      "text": "På denne siden kan du se om data fra din e-postkonto har blitt eksponert i et eksternt datalekkasje. Vi kategoriserer datalekkasjene etter deres alvorlighetsgrad og den typen data som har blitt lekket. Husk å bytte passord hvis dataene dine har blitt lekket.",
      "title": "Har dataene dine blitt lekket?"
    },
    "overview": {
      "text": "Hei {name}! Phishingangrep er den mest utbredte typen cyberangrep på verdensbasis og utgjør en stor sikkerhetsrisiko for arbeidsplassen din. Her på portalen kan du lære enda mer om phishing og andre cyberangrep som kan ramme deg og arbeidsplassen din. Du kan også følge med i fremgangen din og gjennomføre sikkerhetsoppdrag.",
      "title": "Velkommen til læringsportalen!"
    },
    "quiz": {
      "text": "Ta en interaktiv quiz som utfordrer dine evner til å skille mellom ekte e-poster og phishing-e-poster. Quizen er designet for å teste din kunnskap og forståelse av de truslene du kan møte i virkeligheten.",
      "title": "Ta en quiz"
    },
    "simulations": {
      "text": "På denne siden kan du se detaljer om de phishing-simuleringene du har mottatt de siste 90 dagene. Ved å gjennomgå detaljene får du en bedre forståelse av hvordan phishing-e-poster er bygget opp, og hvordan du beskytter deg mot dem.",
      "title": "Er du blitt phishet?"
    },
    "videos": {
      "text": "Her på siden kan du se videoer om cybertrusler og lære hvordan du beskytter deg selv og din arbeidsplass mot dem. Det kommer løpende nye treningsvideoer, så du alltid har mulighet til å tilegne deg ny kunnskap.",
      "title": "Gjør deg klar til å lære noe nytt"
    }
  },
  "certificate": {
    "certificate_of_completion": "Sertifikat for gjennomføring",
    "certificate_unlocked": "Sertifikat aktivert",
    "share_on_linkedin": "Del på LinkedIn",
    "show_certificate": "Vis sertifikat",
    "text": "Du har oppnådd et sertifikat fra ditt siste kurs – hvorfor ikke vise det frem?"
  },
  "courses": {
    "all": "Alle kurs",
    "completed": {
      "badge": "Gjennomført",
      "button": "Fullfør kurset",
      "text": "Du har gjennomført kurset",
      "title": "Godt gjort!"
    },
    "content": {
      "breach": {
        "text": "Aktiver overvåkning av databrudd på kontoen din",
        "title": "Overvåkning av datalekkasjer"
      },
      "download": {
        "button": "Last ned"
      },
      "introduction": {
        "contents": "Innhold",
        "start": "Start kurs",
        "text": "Kursbeskrivelse og oversikt",
        "title": "Introduksjon"
      },
      "quiz": {
        "choose_answer": "Velg det riktige svaret nedenfor:",
        "correct": "Korrekt",
        "correct_answer": "{label}: {answer}",
        "correct_answer_label": "Riktig svar",
        "next_question": "Neste spørsmål",
        "oh_no": "Øv!",
        "question_of": "Spørsmål {current} av {total}",
        "result": {
          "button": "Fullfør quiz",
          "text": "Du svarte korrekt på {correct} av {total} spørsmål.",
          "title": "Godt gjort!",
          "title_fail": "Tett på!"
        },
        "text": "Sett ferdighetene dine på prøve med en quiz",
        "title": "Quiz",
        "view_results": "Gå til resultat",
        "well_done": "Godt gjort!",
        "your_answer": "{label}: {answer}",
        "your_answer_label": "Ditt svar"
      },
      "video": {
        "text": "Lær de viktigste begrepene ved å se denne videoen"
      }
    },
    "continue": "Fortsett",
    "featured": "Utvalgte kurs",
    "lessons": "{count} leksjoner",
    "progress": {
      "button": "Gjenoppta",
      "text": "Du har gjennomført {pct}% av dette kurset."
    },
    "skip_video": {
      "button": "Hopp over",
      "text": "Du har sett denne videoen før. Vil du hoppe over den?"
    },
    "start_over": "Start forfra",
    "title": "Kurs"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "Spørsmålet er utløpt",
        "network": "En feil har oppstått",
        "noResponse": "Det oppstod en serverfeil",
        "streaming": {
          "manifest": "Det oppstod en feil under avspilling av videoen",
          "platform": "Din plattform støtter ikke streaming av video.",
          "unavailable": "Denne videoen er ikke tilgjengelig"
        },
        "unknown": "En ukjent feil har oppstått"
      },
      "messages": {
        "auth_failed": "Ugyldig e-post",
        "csrf": "Last inn siden på nytt og prøv igjen",
        "email_missing": "Ingen e-postadresse tilknyttet konto",
        "file_not_found": "Filen eksisterer ikke",
        "general_exception": "En feil har oppstått",
        "invalid_answer": "Ugyldig svar",
        "invalid_course": "Ugyldig kursus",
        "invalid_domain": "Ugyldig domene",
        "invalid_email": "E-posten er ugyldig",
        "invalid_grant": "Udbyder kunne ikke kontaktes",
        "invalid_locale": "Oversettelse eksisterer ikke",
        "invalid_option": "Ugyldig svaralternativ",
        "invalid_permissions": "Du har ikke tillatelse til å bruke denne funksjonen",
        "invalid_point": "Ugyldig poeng",
        "invalid_provider": "Ugyldig leverandør",
        "invalid_quiz": "Quizzen eksisterer ikke",
        "invalid_token": "Din økt har utløpt",
        "invalid_video": "Denne videoen eksisterer ikke",
        "missing_code": "Prøv vennligst igjen",
        "two_factor_code_expired": "Engangskoden har utløpt",
        "two_factor_code_invalid": "Engangskoden er ugyldig",
        "unauthorized": "Du har ikke tillatelse til å bruke denne funksjonen",
        "user_not_found": "Brukeren eksisterer ikke"
      },
      "validations": {
        "messages": {
          "throttle": "For mange påloggingsforsøk. Prøv igjen senere."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Konto saldi",
        "address_book_contacts": "Adressebok",
        "age_groups": "Aldersgrupper",
        "ages": "Alder",
        "appointments": "Avtaler",
        "apps_installed_on_devices": "Apper installert på enheter",
        "astrological_signs": "Astrologiske tegn",
        "audio_recordings": "Lydopptak",
        "auth_tokens": "API-tokens",
        "avatars": "Profilbilde",
        "bank_account_numbers": "Bankkonto",
        "beauty_ratings": "Skjønnhetsvurderinger",
        "biometric_data": "Biometriske data",
        "bios": "Biografi",
        "browser_user_agent_details": "Nettleserdetaljer",
        "browsing_histories": "Nettleserhistorier",
        "buying_preferences": "Kjøpspreferanser",
        "car_ownership_statuses": "Bileierskapsstatus",
        "career_levels": "Karrierestatus",
        "cellular_network_names": "Mobilnettverk",
        "charitable_donations": "Velgørende donasjoner",
        "chat_logs": "Chatlogger",
        "credit_card_cvv": "Kredittkort CVV",
        "credit_cards": "Kredittkort",
        "credit_status_information": "Kredittstatusinformasjon",
        "customer_feedback": "Kundefeedback",
        "customer_interactions": "Kundeinteraksjoner",
        "dates_of_birth": "Fødselsdatoer",
        "deceased_date": "Afdødedato",
        "deceased_statuses": "Afdødestatus",
        "device_information": "Enhetsinformasjon",
        "device_serial_numbers": "Enhets serienumre",
        "device_usage_tracking_data": "Enhetens bruk sporingsdata",
        "drinking_habits": "Drikkevaner",
        "driver_s_licenses": "Førerens lisenser",
        "drug_habits": "Stoffinntak",
        "eating_habits": "Spisevaner",
        "education_levels": "Utdanningsnivå",
        "email_addresses": "E-postadresse",
        "email_messages": "E-postmeldinger",
        "employers": "Arbeidsgiver",
        "employment_statuses": "Beskjeftelsesstatus",
        "encrypted_keys": "Krypterte nøkler",
        "ethnicities": "Etnisiteter",
        "family_members_names": "Familiemedlemmers navn",
        "family_plans": "Familieplaner",
        "family_structure": "Familiestruktur",
        "financial_investments": "Finansielle investeringer",
        "financial_transactions": "Finansielle transaksjoner",
        "fitness_levels": "Fitnessnivåer",
        "genders": "Kjønn",
        "geographic_locations": "Geografiske steder",
        "government_issued_i_ds": "ID-kort",
        "health_insurance_information": "Helseforsikringsinformasjon",
        "historical_passwords": "Historiske adgangskoder",
        "hiv_statuses": "Hiv-status",
        "home_loan_information": "Informasjon om boliglån",
        "home_ownership_statuses": "Boligeierskapsstatus",
        "homepage_ur_ls": "Nettadresser",
        "imei_numbers": "IMEI-nummer",
        "imsi_numbers": "IMSI-nummer",
        "income_levels": "Inntektsnivåer",
        "instant_messenger_identities": "Instant Messenger-bruker",
        "ip_addresses": "IP-adresser",
        "job_applications": "Søknader",
        "job_titles": "Jobbtittel",
        "licence_plates": "Lisenser",
        "living_costs": "Leveomkostnader",
        "login_histories": "Påloggingshistorikk",
        "mac_addresses": "MAC-adresser",
        "marital_statuses": "Ekteskapsstatus",
        "mnemonic_phrases": "Sikkerhetsspørsmål",
        "mothers_maiden_names": "Sikkerhetsspørsmål",
        "names": "Navne",
        "nationalities": "Nasjonaliteter",
        "net_worths": "Inntektsnivåer",
        "nicknames": "Kallenavn",
        "occupations": "Erverv",
        "parenting_plans": "Foreldreplaner",
        "partial_credit_card_data": "Delvis kreditkortdata",
        "partial_dates_of_birth": "Delvise fødselsdatoer",
        "passport_numbers": "Pasoplysninger",
        "password_hints": "Adgangskode tips",
        "password_strengths": "Adgangskodes lengde",
        "passwords": "Adgangskode",
        "payment_histories": "Betalingshistorikk",
        "payment_methods": "Betalingsmetoder",
        "personal_descriptions": "Personlige beskrivelser",
        "personal_health_data": "Personlige helseopplysninger",
        "personal_interests": "Personlige interesser",
        "phone_numbers": "Telefonnumre",
        "photos": "Fotos",
        "physical_addresses": "Fysiske adresser",
        "physical_attributes": "Fysiske attributter",
        "pi_ns": "PI-nummer",
        "places_of_birth": "Fødselssted",
        "political_donations": "Politiske donasjoner",
        "political_views": "Politiske synspunkter",
        "private_messages": "Private beskjeder",
        "professional_skills": "Faglige kvalifikasjoner",
        "profile_photos": "Profilbilder",
        "purchases": "Kjøp",
        "purchasing_habits": "Innkjøpsvaner",
        "races": "Løpevaner",
        "recovery_email_addresses": "Historisk e-postadresse",
        "relationship_statuses": "Forholdsstatus",
        "religions": "Religioner",
        "reward_program_balances": "Belønningsprogrammer",
        "salutations": "Hilsener",
        "school_grades_class_levels": "Skolekarakterer",
        "security_questions_and_answers": "Sikkerhetsspørsmål og svar",
        "sexual_fetishes": "Seksuelle fetisjer",
        "sexual_orientations": "Seksuell orientering",
        "smoking_habits": "Røykevaner",
        "sms_messages": "SMS-meldinger",
        "social_connections": "Sosiale forbindelser",
        "social_media_profiles": "Sosiale medier-profiler",
        "social_security_numbers": "CPR-nummer",
        "spoken_languages": "Talte språk",
        "spouses_names": "Navn på ektefelle",
        "support_tickets": "Støttebilletter",
        "survey_results": "Undersøkelsesresultater",
        "taxation_records": "Beskatningsposter",
        "time_zones": "Tidssoner",
        "travel_habits": "Reisevaner",
        "user_statuses": "Brukerstatus",
        "user_website_ur_ls": "Brugerwebstedets nettadresser",
        "usernames": "Brukernavn",
        "utility_bills": "Regninger",
        "vehicle_details": "Kjøretøy detaljer",
        "website_activity": "Hjemmesideaktivitet",
        "work_habits": "Arbeidvaner",
        "years_of_professional_experience": "Anciennitet"
      }
    },
    "certificates": {
      "compliance": "Cybersikkerhetstrening"
    },
    "courses": {
      "toc": {
        "breach-content": "Datalekkasjer",
        "file-content": "Last ned",
        "intro-content": "Introduksjon",
        "quiz-content": "Quiz",
        "text-content": "Sak",
        "video-content": "Video"
      }
    },
    "locales": {
      "current": "norsk",
      "da_DK": "dansk",
      "de_DE": "tysk",
      "en_US": "engelsk",
      "es_ES": "Spansk",
      "fi_FI": "finsk",
      "fr_FR": "Fransk",
      "nb_NO": "norsk",
      "nl_NL": "nederlandsk",
      "pl_PL": "polsk",
      "pt_PT": "portugisisk",
      "sv_SE": "svensk"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "Velkommen til din personlige læringsplattform! Vi er glade for å ha deg med og er ivrige etter å hjelpe deg med å nå dine læringsmål.",
              "title": "Velkommen til Moxso"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "Slik fungerer Moxso",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "Velkommen til 🙌",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Personvernsbevissthet",
          "options": {
            "high": "Kjent",
            "low": "Ikke kjent",
            "medium": "Noe kjent"
          },
          "question": "Hvor kjent er du med de grunnleggende prinsippene for personvern (f.eks. GDPR)?"
        },
        "device_security": {
          "category": "Enhetssikkerhetspraksis",
          "options": {
            "high": "Ja, alltid",
            "low": "Nei, aldri",
            "medium": "Noen ganger"
          },
          "question": "Oppdaterer du enhetene dine regelmessig og bruker sikkerhetsverktøy som VPN?"
        },
        "digital_threats": {
          "category": "Bevissthet om digitale trusler",
          "options": {
            "high": "Kjent",
            "low": "Ikke kjent",
            "medium": "Noe kjent"
          },
          "question": "Hvor kjent er du med digitale trusler som malware, phishing og ransomware?"
        },
        "hybrid_work": {
          "category": "Fjernarbeidssikkerhet",
          "options": {
            "high": "Veldig selvsikker",
            "low": "Ikke selvsikker",
            "medium": "Noe selvsikker"
          },
          "question": "Hvor selvsikker er du på å opprettholde sikkerheten når du jobber eksternt (f.eks. på offentlig Wi-Fi)?"
        },
        "incidents_breaches": {
          "category": "Rapportering av hendelser",
          "options": {
            "high": "Ja",
            "low": "Nei",
            "medium": "Jeg har en generell idé"
          },
          "question": "Vet du den korrekte prosedyren for å rapportere en sikkerhetshendelse eller brudd?"
        },
        "passwords_accounts": {
          "category": "Passordhåndtering",
          "options": {
            "high": "Jeg bruker en passordbehandler",
            "low": "Jeg bruker passord på nytt",
            "medium": "Jeg lager unike, sterke passord"
          },
          "question": "Hvordan håndterer du passordene for arbeidsrelaterte kontoer?"
        },
        "phishing": {
          "category": "Phishing-identifikasjon",
          "options": {
            "high": "Veldig selvsikker",
            "low": "Ikke selvsikker",
            "medium": "Noe selvsikker"
          },
          "question": "Hvor selvsikker er du på å gjenkjenne phishingforsøk i e-poster eller meldinger?"
        },
        "physical_security": {
          "category": "Fysisk sikkerhetspraksis",
          "options": {
            "high": "Alltid",
            "low": "Sjeldent",
            "medium": "Noen ganger"
          },
          "question": "Hvor ofte sikrer du arbeidsområdet ditt (f.eks. ved å låse datamaskinen din, oppbevare sensitive dokumenter)?"
        },
        "secure_browsing": {
          "category": "Sikre nettleservaner",
          "options": {
            "high": "Ja, alltid",
            "low": "Nei, aldri",
            "medium": "Noen ganger"
          },
          "question": "Unngår du å bruke offentlig Wi-Fi eller klikke på mistenkelige lenker når du surfer?"
        }
      },
      "steps": {
        "finished": "Ferdig",
        "introduction": "Introduksjon",
        "quiz": "Quiz"
      }
    },
    "partners": {
      "itf": "IT Forum"
    },
    "quiz": {
      "error": {
        "checksum": "Ugyldig svar",
        "option": "Ugyldig svar"
      },
      "intro": {
        "button": "Start quiz",
        "text": "Vi går gjennom 5 e-poster i din Moxso-innboks. Noen av dem kan være fra svindlere som prøver å få tilgang til sensitive data - du må bestemme om e-posten er phishing eller ikke. Er du klar?",
        "title": "Klar til å rapportere?"
      },
      "multiple-choice": {
        "heading": "Finn feilen i e-posten",
        "text": "Velg den riktige feilen i e-posten nedenfor"
      },
      "options": {
        "email": "E-posten",
        "false": "Dette ER IKKE phishing",
        "help": {
          "email": "Afsenderen er IKKE pålitelig",
          "false": "E-posten bør IKKE bli rapportert",
          "link": "Linket fører IKKE til en pålitelig destinasjon",
          "not-phishing": "Dette ER IKKE phishing",
          "true": "E-posten bør bli rapportert"
        },
        "link": "Linket",
        "not-phishing": "Dette ER IKKE phishing",
        "true": "Dette ER phishing"
      },
      "title": "Quiz",
      "true-false": {
        "heading": "Er dette en phishing-e-post?",
        "text": "Finn ut om dette er en phishing-e-post eller ikke"
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "Dette kurset kan ikke åpnes. Valgfrie kurs er låst, men obligatorisk opplæring er alltid tilgjengelig.",
          "title": "Kursgrense nådd"
        },
        "quiz": {
          "description": "Du har nådd treningsgrensen din. Valgfrie quizer er midlertidig låst.",
          "title": "Quizgrense nådd"
        },
        "video": {
          "description": "Du har nådd treningsgrensen din. Valgfrie videoer er låst, men obligatorisk opplæring er alltid tilgjengelig.",
          "title": "Videogrense nådd"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "Dette kurset kan ikke åpnes. Valgfrie kurs er låst, men obligatorisk opplæring er alltid tilgjengelig.",
        "title": "Kursgrense nådd"
      },
      "quiz": {
        "description": "Du har nådd treningsgrensen din. Valgfrie quizer er midlertidig låst.",
        "title": "Quizgrense nådd"
      },
      "reset": "Tilbakestilles mandag",
      "video": {
        "description": "Du har nådd treningsgrensen din. Valgfrie videoer er låst, men obligatorisk opplæring er alltid tilgjengelig.",
        "limit_reached": "Grense nådd",
        "title": "Videogrense nådd"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "Avansert er en serie for dem som er spesielt interessert i IT-sikkerhet og i å forstå hvordan de underliggende mekanismene innen hacking og IT-sikkerhet fungerer. Hvis du bare ønsker en grunnleggende forståelse for IT-sikkerhet, er det ikke nødvendig for deg å se videoene i denne serien. Hvis du gjerne vil vite mer om hacking og cyberangrep, samt hvordan du best kan sikre din egen IT-sikkerhet, så finner du svaret her.",
          "title": "Avansert",
          "tooltip": "Bli ekspert i hacking på rekordtid"
        },
        "ai": {
          "text": "AI-serien dykker ned i den komplekse rolle som kunstig intelligens spiller i cybersikkerhet. AI tjener et dobbelt formål: Det er et avgjørende verktøy for IT-sikkerhetsfolk til å identifisere og håndtere trusler, samtidig som det er et effektivt våpen for hackere. Denne videoserien har som mål å øke din bevissthet om AI-genererte phishing-angrep og veilede deg i å bruke AI på en sikker måte for å minimere feil og redusere risikoen for hacking. For selv om AI er et viktig verktøy i både cyberforsvar og -angrep, er din atferd fortsatt den avgjørende faktoren for din sikkerhet.",
          "title": "AI og cybersikkerhet",
          "tooltip": "Utforsk AIs komplekse rolle innen cybersikkerhet"
        },
        "compliance": {
          "text": "Denne kategori inneholder videoer om viktige lover, sikkerhetsstandarder og sertifiseringer, som kan være med på å beskytte arbeidsplassen din mot digitale trusler. Videoene gir deg blant annet innblikk i NIS2-direktivet og DORA-forordningen, som sikrer robuste cybersikkerhetsforanstaltninger og overholdelse av internasjonale standarder. Videoene gir innsikt i regelverkets betydning, hvordan man oppnår compliance, og hvilke konkrete krav de stiller til virksomheters sikkerhet og risikostyring. Du får også forståelse for hva reglene betyr for deg, og hvorfor de er verdt å bruke tid på.",
          "title": "Sertifiseringer og samsvar",
          "tooltip": "Få innsikt i betydningen av sertifiseringer og overholdelse"
        },
        "gdpr": {
          "text": "GDPR er en serie som dykker ned i de reglene, kravene og prinsippene som er fastsatt i GDPR. GDPR ble innført i 2018, og alle virksomheter må nå overholde GDPR, slik at de kan sikre integriteten og beskyttelsen av de personopplysningene de behandler. Serien tar for seg de mest relevante områdene innen GDPR som du bør kjenne til, slik at du kan behandle personopplysninger korrekt i din hverdag. Denne serien inneholder både videoer som er rettet mot alle, og videoer som er rettet mot ansatte i den private sektoren.",
          "title": "GDPR",
          "tooltip": "Lær de viktigste kravene og reglene i GDPR, og hvordan du kan overholde dem i din hverdag."
        },
        "hacking": {
          "text": "Livet som hacker er en serie, hvor vi har fokus på de IT-kriminelle, nemlig hackerne. Vi ser nærmere på noen av metodene som hackere bruker for å forbli anonyme på nettet, og hvordan de tjener pengene sine. I videoene vil du ytterligere lære hvilke typer hackere som finnes, og hvorfor hackere er så vanskelige å fange.",
          "title": "Livet som hacker",
          "tooltip": "Kom bak fasaden på verdens IT-kriminelle, nemlig hackerne"
        },
        "money_laundering": {
          "text": "Hvitvasking er en serie som går i dybden med de forskjellige metodene som kriminelle bruker til å hvitvaske penger. Videoene vil forklare de forskjellige metodene som kriminelle bruker til å hvitvaske penger, og hvordan man oppdager og forebygger hvitvasking.",
          "title": "Hvitvasking",
          "tooltip": "Lær de forskjellige metodene som kriminelle bruker til å hvitvaske penger, og hvordan man oppdager og forebygger hvitvasking"
        },
        "phishing": {
          "text": "Phishing er en serie som går i dybden med det mest utbredte cyberangrepet globalt. Phishing-angrep kan både stå alene og brukes som en måte å innlede andre, og mer avanserte, cyberangrep på. Phishing-angrep er dessuten det cyberangrepet hvor du som ansatt alene bærer ansvaret for ikke å bli hacket, f.eks. ved å unngå å klikke på en lenke i en e-post. Phishing er et essensielt fokusområde innen IT-sikkerhet, og videoene i denne serien gir deg forståelsen for hva phishing er, hvordan det utføres, og hvordan du unngår å bli offer for et phishing-angrep.",
          "title": "Phishing",
          "tooltip": "Få inngående kunnskap om det mest utbredte cyberangrepet globalt"
        },
        "physical_security": {
          "text": "Fysisk sikkerhet er en serie som belyser viktigheten av god sikkerhet på arbeidsplassen og i hjemmet. Cybersikkerhet handler om mer enn sikkerheten på enhetene dine, det handler også om sikkerheten rundt enhetene. Mange er kjent med fjernarbeid, og vi forbereder deg på å gjøre dette så sikkert som mulig. I denne serien får du i tillegg innblikk i alt fra besøkshåndtering, til cybersikkerhet på mobile enheter og hvilke risikoer det er ved å bruke offentlige nettverk.",
          "title": "Fysisk sikkerhet",
          "tooltip": "Få et innblikk i hvorfor fysisk sikkerhet er et viktig element i sterk cybersikkerhet"
        },
        "tips_and_tricks": {
          "text": "Tips og triks er en serie som hjelper deg med å øke din sikkerhet på nettet. Du vil få helt konkrete, lavpraktiske råd om hvordan du kan øke din personlige sikkerhet på nettet og dermed også øke sikkerheten på din arbeidsplass. Videoene forklarer ytterligere hvorfor de sikkerhetsrådene du kanskje tidligere har mottatt fra andre enn oss her i Moxso, er så viktige å huske.",
          "title": "Tips og triks",
          "tooltip": "Lær hvordan du kan øke din sikkerhet på nettet"
        },
        "types_of_hacking": {
          "text": "Typer av hacking er en serie som gir deg innsikt i de forskjellige metodene som hackere har tilgjengelig når de prøver å lure deg. Hver episode gir deg en grunnleggende forståelse for en spesifikk hackingmetode. Dette innebærer kjennetegnene for hackingmetoden, hva hackerne kan få ut av nettopp den metoden, konsekvensene det kan få for deg hvis du blir hacket m.m. Ved å se videoene i denne serien lærer du hvordan hackerne arbeider, og du vil bli bedre rustet mot hackerangrep i fremtiden.",
          "title": "Typer av hacking",
          "tooltip": "Få et innblikk i de forskjellige metodene som hackere bruker"
        },
        "uploads": {
          "text": "Denne kategorien inneholder tilpassede videoer lastet opp av organisasjonen din.",
          "title": "Opplastinger",
          "tooltip": "Se videoer lastet opp av organisasjonen din for dine spesifikke sikkerhetsbehov"
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "Feilen har blitt sendt til vårt team med id: {errorId}. Hvis du trenger øyeblikkelig hjelp, er du velkommen til å kontakte vårt supportteam på support{'@'}moxso.com.",
    "go_back": "Tilbake til startsiden",
    "text": "Det oppstod en ukjent feil, og vi kunne ikke fullføre din forespørsel. Vi beklager ubeleiligheten. Vennligst prøv igjen senere.",
    "title": "Noe gikk galt"
  },
  "forms": {
    "fields": {
      "code": "Engangskode",
      "email": "E-post"
    },
    "placeholders": {
      "email": "navn{'@'}firma.dk"
    }
  },
  "loading": "Indlaster",
  "locale": {
    "current": "Norsk",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Logg inn",
      "next": "Neste",
      "send_one_time_code": "Send engangskode",
      "try_again": "Send koden på nytt"
    },
    "choose_provider": "Velg leverandør",
    "loading": "Indlaster",
    "sso": {
      "validating": "Validerer SSO"
    },
    "title": "Logg inn",
    "two_factor": {
      "text": "Vi har sendt en engangsadgangskode til din e-post.",
      "title": "Sjekk din e-post"
    }
  },
  "mandatory": {
    "completed": {
      "text": "Du har gjennomført alt innholdet som din administrator har valgt for deg.",
      "title": "Godt gjort!"
    },
    "deadline": "Frist for gjennomføring: {date}",
    "next_training": "Neste tildelte trening",
    "policy_fallback_title": "Politikk",
    "quiz_questions": "{count} spørsmål",
    "retake": "Gentildelt",
    "start_quiz": "Start quiz",
    "text": "Din tildelte trening",
    "title": "Tildelt trening",
    "view_policy": "Vis policy"
  },
  "navigation": {
    "breaches": "Datalekkasje",
    "courses": "Kurs",
    "exit": "Avslutt",
    "exit_onboarding": "Vår over",
    "login": "Logg inn",
    "logout": "Logg ut",
    "onboarding": "Introduksjon",
    "onboarding_finished": "Onboarding ferdig",
    "onboarding_intro": "Onboarding introduksjon",
    "onboarding_quiz": "Onboarding quiz",
    "overview": "Oversikt",
    "simulation_click": "Phishing-simulering",
    "simulations": "Simuleringer",
    "videos": "Videoer"
  },
  "onboarding": {
    "finished": {
      "button": "Start læring",
      "subtitle": "Du har fullført onboarding-prosessen! Bra jobba, du er nå klar til å begynne å bruke Moxso. Vi er glade for å ha deg ombord og gleder oss til å hjelpe deg med å nå målene dine!",
      "title": "Det var det!"
    },
    "intro": {
      "form": {
        "button": "Lagre og fortsett",
        "help": "Velg språket du vil bruke for læringsopplevelsen din.",
        "label": "Velg ditt språk",
        "placeholder": "Velg språk"
      },
      "header": {
        "description": "Velkommen til din læringsplattform! Vi er glade for å ha deg her og er klare til å hjelpe deg med å nå målene dine. La oss sette opp profilen din og tilpasse opplevelsen din.",
        "title": "Velkommen til Moxso"
      }
    },
    "quiz": {
      "header": {
        "description": "Fullfør denne korte quizen for å hjelpe oss med å forstå ditt nåværende nivå, slik at vi kan tilpasse opplæringen etter dine behov.",
        "title": "Hvor godt kjenner du cybersikkerhet?"
      }
    }
  },
  "overview": {
    "start_quiz": "Ta en quiz",
    "welcome": "Velkommen tilbake"
  },
  "partner_text": "Moxsos plattform presenteres i samarbeid med {partner}.",
  "policies": {
    "cancel": {
      "text": "Denne policyen har blitt avbrutt av din administrator.",
      "title": "Avbrutt policy"
    },
    "continue": "Fortsett",
    "expired": {
      "text": "Denne policyen har utløpt og er ikke lenger tilgjengelig.",
      "title": "Utløpt policy"
    },
    "focus": "Fokus",
    "history": {
      "count": "{count} signerte",
      "show_less": "Vis mindre",
      "signed": "Signert: {date}",
      "subtitle": "Se gjennom policyer du allerede har signert.",
      "title": "Signerte policyer",
      "view_more": "Vis mer"
    },
    "next": "Neste",
    "overview": "Innholdsoversikt",
    "policy": "Politikk",
    "quiz": {
      "confirmation_card_locked": "Du må fullføre quizen for å fortsette",
      "subtitle": "Test din forståelse av retningslinjene ved å ta denne quizen.",
      "subtitle_completed": "Du har fullført quizen. Bekreft at du har lest retningslinjene for å fullføre.",
      "title": "Quiz",
      "title_completed": "Quiz fullført"
    },
    "reader": "Leseløsning",
    "signature": {
      "button": "Godkjenn",
      "checkbox_label": "Jeg har lest policyen",
      "company": "Selskap",
      "completed": {
        "button": "Avslutt",
        "policy_completed": "Politikk akseptert",
        "subtitle": "Bra gjort! Du har akseptert politikken.",
        "title": "Politikk akseptert"
      },
      "ip_adress": "IP-adresse",
      "subtitle": "Ved å bekrefte bekrefter du at du har lest og forstått retningslinjene.",
      "title": "Bekreft lesing av retningslinjer",
      "user_agent": "Brukeragent"
    },
    "this_policy_doesnt_exist_in_this_language": "Denne policyen er ikke tilgjengelig på norsk. Viser {locale}-versjonen."
  },
  "quiz": {
    "analyze": {
      "text": "Analyser e-posten og få hjelp",
      "title": "Er du usikker?"
    },
    "feedback": {
      "no": "Nei",
      "text": "Var denne artikkelen nyttig?",
      "thanks": "Takk for tilbakemeldingen!",
      "yes": "Ja"
    },
    "help": {
      "button": "Neste spørsmål",
      "text": "Vi har analysert e-posten og funnet følgende resultat",
      "title": "Mailanalyse"
    },
    "intro": {
      "button": "Start quiz",
      "text": "Vi går gjennom 5 e-poster i din Moxso-innboks. Noen av dem kan være fra svindlere som prøver å få tilgang til sensitiv data - du må avgjøre om e-posten er phishing eller ei. Er du klar?",
      "title": "Klar til å rapportere?"
    },
    "preview": "E-postvisning",
    "question": "Spørsmål {current} av {total}",
    "result": {
      "go_back": "Gå til din oversikt",
      "mails": "Korrekt e-post | Korrekte e-poster",
      "points": "Poeng opptjent",
      "text": {
        "bad": "Du kategoriserte dessverre kun {count} e-post riktig. Men husk: Øvelse gjør mester! | Du kategoriserte dessverre kun {count} e-poster riktig. Men husk: Øvelse gjør mester!",
        "good": "Du kategoriserte {count} e-poster korrekt og fullførte quizen. Fortsett det gode arbeidet!"
      },
      "title": {
        "bad": "Bedre lykke neste gang!",
        "good": "Bra jobba!"
      }
    },
    "title": "Quiz"
  },
  "resilience_score": {
    "long_text": "Din poengsum for motstandsdyktighet måler din evne til å motstå cyberangrep. Poengsummen beregnes ut fra din atferd i quizzer, videoer og simuleringer. Jo høyere din motstandsdyktighet er, jo bedre er du til å beskytte deg selv og din virksomhet mot cyberangrep.",
    "quizzing": {
      "text": "Øk din motstandskraft ved å ta flervalgstester etter hver video.",
      "title": "Quiz"
    },
    "show_breakdown": "Vis detaljer",
    "simulations": {
      "text": "Sikker phishing-adferd forbedrer din motstandskraft. Klikk aldri, og husk å rapportere!",
      "title": "Simuleringer"
    },
    "skills": {
      "text": "Dine ferdigheter avhenger av hvordan du svarer på quizzer. Korrekte svar øker motstandsdyktigheten.",
      "title": "Ferdigheter"
    },
    "text": "Din score måler din evne til å motstå cyberangrep.",
    "title": "Din motstandsdyktighet",
    "videos": {
      "text": "Videoer er en viktig del av din trening. Øk din motstandskraft ved å se videoer.",
      "title": "Videoer"
    }
  },
  "search": {
    "empty": "Søk blant videoer og kurs...",
    "no_results": "Ingen resultater funnet",
    "placeholder": "Søk...",
    "popular": "Populære søk",
    "popular_terms": ["Ransomware", "Sosial ingeniørkunst"]
  },
  "simulation": {
    "alert": {
      "text": "Du har klikket på en lenke i et simulert phishing-angrep, men bare rolig, det er bare en øvelse, og ingen skade er skjedd.",
      "title": "Dette er en phishing øvelse"
    },
    "baseline": {
      "text": "Vi tester akkurat nå dine kollegaer, så vennligst del ikke denne beskjeden med noen.",
      "title": "Kan du holde på en hemmelighet?"
    },
    "branding": {
      "text": "Hvis du har noen spørsmål eller trenger hjelp, så nøl ikke med å kontakte oss.",
      "title": "Denne øvelse ble levert av Moxso"
    },
    "delivered_by": {
      "text": "Denne øvelsen ble levert av Moxso på vegne av {companyName}. Hvis du har spørsmål, er du velkommen til å kontakte {contactEmail}.",
      "title": "Om denne øvelsen"
    },
    "preview": "Forhåndsvisning",
    "resilience_score": {
      "text": "Din poengsum for motstandskraft måler din evne til å motstå cyberangrep.",
      "title": "Din motstandsdyktighetsscore"
    },
    "submission": {
      "text": "Du klikket på en lenke og havnet på en falsk, men overbevisende nettside. I et ekte phishing-angrep kunne påloggingsinformasjonen din ha blitt stjålet. Heldigvis var dette bare en test.",
      "title": "Hva skjedde nettopp?"
    },
    "training": {
      "button": "Start din trening"
    }
  },
  "simulations": {
    "count": "Du har ikke mottatt noen simuleringer de siste 90 dagene. | Du har mottatt én simulering i løpet av de siste 90 dagene. | Du har mottatt {count} simuleringer i løpet av de siste 90 dagene.",
    "empty": {
      "text": "Du har ikke mottatt noen simuleringer de siste 90 dagene.",
      "title": "Ingen simuleringer"
    },
    "joined": "Du ble påmeldt treningsprogrammet",
    "title": "Simuleringer",
    "tooltip": {
      "click": "Du har klikket på lenken i denne simuleringen.",
      "report": "Du har rapportert denne simuleringen.",
      "submit": "Du har logget inn på denne simuleringen."
    }
  },
  "sso": {
    "login_with": "Fortsett med {provider}",
    "or": "eller benytt SSO",
    "redirect": "Omdirigerer"
  },
  "statistics": {
    "leaderboard": "Leaderboard",
    "missing_data": {
      "text": "Du har ikke opptjent nok poeng til å se din plassering på leaderboardet ennå.",
      "title": "Tjen poeng for å se din plassering"
    },
    "points_earned": "{count} poeng opptjent",
    "resilience_score": "Motstandsdyktighet"
  },
  "videos": {
    "error": "Streaming er utilgjengelig for øyeblikket",
    "latest": "Seneste videoer",
    "more": "Vis mer",
    "not_available_in_your_locale": "Denne video er ikke tilgjengelig på dansk. Vi har automatisk byttet til engelsk.",
    "play": "Start video",
    "quiz": {
      "resume": "Fortsett quiz",
      "title": "Quiz"
    },
    "related": "Relaterte videoer",
    "related_videos": "Foreslåtte videoer",
    "title": "Videoer",
    "watch_again": "Se igjen"
  }
}
